export default __webpack_public_path__ + "static/media/WindowsLogo.2237395a.svg";